import {
  AiTranslationWorkflowSortAttributeEnum,
  ContextLibraryUploadedFileSortAttributeEnum,
  GeneratedContentSortAttributeEnum,
  HubspotPageSortAttributeEnum,
  HubspotPageTypeEnum,
  HubspotTableSortAttributeEnum,
  InvoiceSortAttributeEnum,
  PaymentSortAttributeEnum,
  PurchaseOrderSortAttributeEnum,
  SortOrderEnum,
  TransactionSortAttributeEnum,
  TransactionTypeEnum
} from 'gql/graphql';

export const SORT_ATTRIBUTE_CONTEXT_LIBRARY_DEFAULT =
  ContextLibraryUploadedFileSortAttributeEnum.CreatedAt;
export const SORT_ATTRIBUTE_SAVED_AGENTS_DEFAULT = AiTranslationWorkflowSortAttributeEnum.CreatedAt;
export const SORT_ATTRIBUTE_HUBSPOT_DEFAULT = HubspotPageSortAttributeEnum.PublishDate;
export const SORT_ATTRIBUTE_TRANSACTIONS_DEFAULT = TransactionSortAttributeEnum.CreatedAt;
export const SORT_ATTRIBUTE_ORDERS_DEFAULT = PurchaseOrderSortAttributeEnum.CreatedAt;
export const SORT_ATTRIBUTE_INVOICES_DEFAULT = InvoiceSortAttributeEnum.CreatedAt;
export const SORT_ATTRIBUTE_PAYMENTS_DEFAULT = PaymentSortAttributeEnum.CreatedAt;
export const SORT_ATTRIBUTE_HUBDB_DEFAULT = HubspotTableSortAttributeEnum.CreatedAt;
export const HUBSPOT_TYPE_DEFAULT = HubspotPageTypeEnum.LandingPages;
export const TRANSACTION_TYPE_DEFAULT = undefined as TransactionTypeEnum | undefined;
export const SORT_ATTRIBUTE_CONTENT_GENERATION_DEFAULT =
  GeneratedContentSortAttributeEnum.CreatedAt;
export const SORT_ORDER_DEFAULT = SortOrderEnum.Desc;
export const TAGS_ID_DEFAULT = undefined;
export const CONTENT_TYPE_DEFAULT = '';
export const QUERY_DEFAULT = '';
export const QUOTE_DEFAULT = '';
export const TITLE_DEFAULT = '';
export const TOPIC_DEFAULT = '';
export const ADDITIONAL_INSTRUCTIONS_DEFAULT = '';
export const STYLE_GUIDE_DEFAULT = {
  purpose: undefined,
  targetAudience: undefined,
  formality: undefined,
  style: undefined,
  voiceTone: undefined,
  culturalConsiderations: undefined
};
export const STYLE_GUIDE_ID_DEFAULT = undefined;
export const CONTENT_FORMAT_DEFAULT = undefined;
export const LANGUAGE_PAIR_DEFAULT = '';
export const CONTENT_LENGTH_DEFAULT = 0;
export const PAGE_DEFAULT = 1;
export const PAGE_CANT_RESET_DEFAULT = false;
export const LANGUAGES_MULTIPLES_DEFAULT = [];
export const LANGUAGE_DEFAULT = '';
export const CONTEXT_IDS_DEFAULT = [];
export const STATUS_DEFAULT = [] as string[];
export const LANGUAGES_DEFAULT = { sourceLanguageCode: undefined, targetLanguageCode: undefined };
export const DATE_RANGE_DEFAULT = { startDate: null, endDate: null };
export const DATE_PREFERRED_DEFAULT = { startDate: null, endDate: null };
export const QUALITY_DEFAULT = undefined;
export const EDITOR_ID_DEFAULT = undefined;
export const PO_CODE_DEFAULT = undefined;
export const SHOW_DUPLICATES_DEFAULT = true;
export const TRANSLATED_BY_AGENT_DEFAULT = false;
export const COMMENTS_DEFAULT = undefined;
export const WORKFLOW_ID_DEFAULT = undefined;
export const USER_ID_DEFAULT = undefined;
export const INVOICE_ID_DEFAULT = undefined;
export const TRANSLATION_REQUEST_VERSION_DEFAULT = undefined;
export const TASK_ID_DEFAULT = undefined;
export const SEARCH_DEFAULT = '';
export const REPLACE_DEFAULT = '';
